import React, { useState } from 'react';
import { Tooltip } from '../../../common';
import { InfoCircleIcon } from '../../../../content/svg-component';
import { numberWithCommas } from '../../../../utils/consts';
import PassengerTable from '../../booking/passengerTable';
import './recentTravelsItems.scss';

function RecentTravelsItems({ flightValue, style, language, intl }) {
  const [showPassengerDetailId, setShowPassengerDetailId] = useState('');
  const { direction, name } = language;

  const returnDirection = (itineraries, name) => {
    let direction = '',
      sameAirport = false;
    itineraries.map((item, index) => {
      let directionArray = direction.split('-');

      directionArray.length > 0 &&
      directionArray[directionArray.length - 1].includes(
        itineraries[index].flights[0].departureAirport.cityName[name],
      )
        ? (sameAirport = true)
        : (sameAirport = false);

      direction += ` ${
        sameAirport
          ? ''
          : itineraries[index].flights[0].departureAirport.cityName[name]
      }
      - ${
        itineraries[index].flights[itineraries[index].flights.length - 1]
          .arrivalAirport.cityName[name]
      }`;
    });
    return direction;
  };

  const emailValue = flightValue?.issuerContactInfo?.email || '---';
  const nameValue = flightValue.passengers
    ? `${flightValue.passengers[0].firstName.toLowerCase()} ${flightValue.passengers[0].lastName.toLowerCase()}`
    : '---';
  const avatar = flightValue.passengers[0].avatar;
  const flightAirlines =
    flightValue?.flights?.itineraries.length === 1
      ? `${
          flightValue.serviceType.name
            ? flightValue.serviceType.name[name]
            : direction === 'rtl'
            ? intl.formatMessage({
                id: 'booking.flights',
              })
            : ''
        } ${
          flightValue?.flights?.itineraries[0]?.flights[0]?.operatingAirline
            .name[name]
        }`
      : `${intl.formatMessage({
          id: 'booking.multiairline',
        })}`;
  const passangerCount =
    flightValue?.flights?.adultCount +
    flightValue?.flights?.childCount +
    flightValue?.flights?.infantCount +
    flightValue?.flights?.citizenCount +
    flightValue?.flights?.toddlerCount +
    flightValue?.flights?.studentCount;
  const destinationValue = returnDirection(
    flightValue?.flights?.itineraries,
    name,
  );

  return (
    <div
      className={`d-flex align-items-center justify-content-between position-relative ${style}`}
      onMouseLeave={() => {
        document.querySelectorAll(`.flightTabel`).forEach((item) => {
          item.classList.replace('d-flex', 'd-none');
        });
        setShowPassengerDetailId(0);
      }}
      style={{ borderTop: '1.5px dashed var(--third)', fontSize: '0.8vw' }}
    >
      {showPassengerDetailId === flightValue._id && (
        <div
          className={`d-flex text-center col-12 px-0 position-absolute flightTabel`}
          style={{
            zIndex: 50,
            bottom: '90%',
            right: direction === 'rtl' ? '00%' : 'auto',
            left: direction === 'ltr' ? '00%' : 'auto',
            fontSize: '1rem',
          }}
        >
          <div className="card shadow-lg bg-primary-dark-darker default-border-radius-small">
            <PassengerTable
              passengerLst={flightValue.passengers}
              direction={direction}
              className="text-white"
            />
          </div>
        </div>
      )}
      <div className="d-flex align-items-center px-0 col-sm-5 col-4">
        <img
          className="d-sm-flex d-none img-fluid img-responsive col-md-2 col-3 px-0"
          src={require(`../../../../content/images/avatars/${
            avatar || '1.png'
          }`)}
          alt="avatars"
        />
        <div
          className={`d-flex flex-column text-start font-xl-msmall font-lg-smaller font-sm-msmall font-xs-smaller font-xsmall col-md-10 col-sm-9 w-100 px-2 text-nowrap`}
        >
          <div className="w-100 d-flex flex-row">
            <div className="w-100 px-0 d-flex flex-row">
              <span className="text-truncate px-0">
                {nameValue ? nameValue : '---'}
              </span>
              <div className="d-flex align-items-center col-2 p-0 justify-content-start pb-1">
                <div
                  className="px-1"
                  onMouseOver={() => {
                    setShowPassengerDetailId(flightValue?._id);
                    document
                      .querySelectorAll('.flightTabel')
                      .forEach((item) => {
                        item.classList.replace('d-none', 'd-flex');
                      });
                  }}
                >
                  <InfoCircleIcon size={12} />
                </div>
              </div>
            </div>
          </div>

          <div className="w-100 d-flex text-truncate">
            <span className="w-100 text-truncate">
              {emailValue ? emailValue : '---'}
            </span>
          </div>
        </div>
      </div>

      <div className="col-3 px-xl-0 px-lg-1 px-0 font-xl-msmall font-lg-smaller font-sm-msmall font-xs-smaller font-xsmall text-nowrap">
        <div className="w-100 text-center">
          <div className="w-100 px-0 d-flex flex-row">
            <span className="w-100 text-truncate">
              {flightAirlines ? flightAirlines : '---'}
            </span>
          </div>
        </div>

        <div className="w-100 text-third text-center text-nowrap">
          <div className="w-100 px-0 d-flex flex-row">
            <span className="text-truncate w-100">
              {destinationValue ? destinationValue : '---'}
            </span>
          </div>
        </div>
      </div>

      <div
        className={`${
          direction === 'rtl'
            ? 'col-xl-2 col-lg-1 col-2 px-0'
            : ' col-xxl-2 col-lg-1 col-2 px-0'
        } text-white
       d-flex align-items-center justify-content-center`}
      >
        <div className="text-dark rounded-circle d-flex justify-content-center align-items-center">
          <div className="font-msmall">
            {passangerCount ? passangerCount : 1}
          </div>
        </div>
      </div>
      <div
        className={`${
          direction === 'rtl'
            ? 'col-xl-2 col-lg-3 col-sm-2 col-3 px-xl-0 px-lg-2 px-0'
            : 'col-xxl-2 col-lg-3 col-sm-2 col-3 local-padding-price'
        } text-center`}
      >
        <span
          className={`${
            direction === 'rtl'
              ? 'font-xxl-msmall font-lg-smaller font-msmall'
              : 'font-xl-smaller font-lg-xsmall font-sm-smaller font-smaller'
          }`}
        >
          {numberWithCommas(Math.round(flightValue.totalPrice / 10))}
        </span>
        <span
          className={`${
            direction === 'rtl'
              ? 'font-xl-msmall font-lg-xsmall font-sm-msmall font-xsmall'
              : 'font-xsmall font-weight-bold'
          }`}
        >
          {intl.formatMessage({
            id: 'booking.toman',
          })}
        </span>
      </div>
      <div
        className="position-absolute bg-third-light rounded-circle "
        style={{ padding: '0.8rem', top: -13, right: -38 }}
      ></div>
      <div
        className="position-absolute bg-third-light rounded-circle "
        style={{ padding: '0.8rem', top: -13, left: -38 }}
      ></div>
    </div>
  );
}

RecentTravelsItems.propTypes = {};

export default RecentTravelsItems;
